import React from 'react';

const ShowHidePassword = (props) => {
    const { showHidePassword, showPassword = false } = props;
    return (
        <span className="b2c__loginwrap--showeyes" onClick={() => showHidePassword()}>
            {!showPassword ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash"></i>}
        </span>
    )
}

export default ShowHidePassword;